module.exports = __webpack_public_path__ + "ef0c33715571fc302abae47fcf805691.svg";